<template>
  <div>
    <nav-bread>
      <span slot="company">{{providerList.providerName}}</span>
    </nav-bread>
    <div class="binBan pc">
      <img class="banPic" src="../../assets/shoppic.jpg" alt=""/>
      <!--<p class="conName">{{providerList.providerName}}</p>-->
      <!--<div class="banBtn">-->
        <!--<ul>-->
          <!--<li @click="toHome" class="mineCol">-->
            <!--<slot name="index">首页</slot>-->
          <!--</li>-->
          <!--<li @click="toAllGoods">-->
            <!--<slot name="allGoods">全部商品</slot>-->
          <!--</li>-->
          <!--&lt;!&ndash;<li v-bind:class="{'mineCol':!allGoodFlag}" @click="toAllGoods">全部商品</li>&ndash;&gt;-->
        <!--</ul>-->
      <!--</div>-->
    </div>

    <div class="conBan clearfix">
      <el-row>
        <el-col :span="24">
          <div class="fl"><img class="comLogo" :src="providerList.img" alt="" /></div>
          <div class="fr comCon">
            <p>{{providerList.providerName}}
              <el-button class="brief mobile" type="text">
                简介
                <i v-if="!briefFlag" class="el-icon-arrow-down" @click="briefFlag = true"></i>
                <i v-else class="el-icon-arrow-up" @click="briefFlag = false"></i>
              </el-button>
            </p>
            <div class="info" v-if="briefFlag">{{providerList.desc}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <h2>热门推荐</h2>
          <div  class="accessory-list col-5">
            <ul>
              <li v-for="(item,index) in  hotList" :key="index" @click="todetection(item.id,item.remark)">
                <div class="pic">
                  <a href="javascript:;"><img :src="item.img" alt=""></a>
                </div>
                <div class="main">
                  <div class="name">{{item.itemName}}</div>
                  <div class="price">￥{{item.price}}</div>
                </div>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="24">
          <h2>全部商品</h2>
          <div  class="accessory-list col-5">
            <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="30">
              <li v-for="(item,index) in goodsList" :key="index" @click="todetection(item.id,item.remark)">
                <div class="pic">
                  <a href="javascript:;"><img :src="item.img" alt=""></a>
                </div>
                <div class="main">
                  <div class="name">{{item.itemName}}</div>
                  <div class="price">￥{{item.price}}</div>
                  <div class="area">{{item.providerArea}} | {{item.providerName}}</div>
                </div>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>


</template>

<script>

    import '../../assets/css/base.css'
    import '@/assets/css/product.css'


    import axios from 'axios'
    import Tabbar from '@/components/Tabbar.vue'
    import NavHeader from '@/components/Header.vue'
    import NavFooter from '@/components/Footer.vue'
    import NavBread from '@/components/Bread.vue'
    export default {
      name: "com-index",
      data(){
        return {
          id:this.$route.query.id,
          providerList:[],
          allGoodFlag:true,
          hotList: [],
          goodsList: [],
          page: 1,
          limit: 10,
          hasMoreData: true,
          loading: false,
          keywords: '',
          briefFlag: true
        }
      },
      components:{
        Tabbar,
        NavHeader,
        NavFooter,
        NavBread,
      },
      methods:{
        //获取店铺相关信息
        getComInfo(){
          console.info(this.id)
          axios.get("/jys/provider/"+this.id).then((res)=>{
            this.providerList = res.data.info;
            console.info(this.providerList)
          })
        },
        //鼠标滚动时需要加载的方法
        loadMore() {
          // this.page ++
          this.getShopItems()
        },
        gethotList() {
          //axios.defaults.baseURL = 'http://192.168.15.23:8080';
        axios.get("/jys/provider/" + this.id +"/hot").then((res) => {
          this.hotList = res.data.list;
          //axios.defaults.baseURL = process.env.API_ROOT;
          console.info(this.hotList)
        })
       },


//        跳转到首页
        toHome() {
          this.$router.push({path: "/company/index", query: {id: this.id}})
        },

        toAllGoods() {
          this.$router.push({path: "/company/all", query: {id: this.id}})
        },
        todetection(id, remark) {
          this.$router.push({path: "/detection", query: {id: id, remark: remark}})
        },
        //显示商品列表
        getShopItems() {
          this.loading = true
          axios.get("/jys/provider/" + this.id + '/item', {
            params: {
              page: this.page,
              limit: this.limit
            }
          }).then((res) => {
            var goodsListTem = this.goodsList
            if (res.data.code == 0) {
              if (this.page == 1) {
                goodsListTem = []
              }

              //新版
              var goodsList = res.data.page.list

              if (goodsList.length < this.limit) {
                this.goodsList = goodsListTem.concat(goodsList)
                this.loading = true
                this.hasMoreData = false
              } else {
                this.goodsList = goodsListTem.concat(goodsList)
                this.loading = false
                this.hasMoreData = true
                this.page = this.page + 1
              }
            }
          })
        }

      },
      mounted:function(){
        this.getComInfo();
        this.gethotList();
        this.getShopItems();
        this.$store.commit("updateProviderId", this.$route.query.id)
        localStorage.setItem("providerId", this.$route.query.id)
      }


    }
</script>

<style scoped>
  body{font-size: 0;}
  .fl{float: left;}
  .fr{float: right;}
  .conBan{width: 66.66%;margin: 0 auto 55px auto;font-size: 0;}
  .banPic{width: 100%;height: 500px;}
  .binBan{position: relative;}
  .conName{position: absolute;top: 206px;right: 426px;font-size: 39px;font-weight: bold;}
  .banBtn{width: 66.66%;background: #000;height: 40px;position: absolute;bottom: 0;left: 17%;}
  .banBtn ul li{display: inline-block;height: 40px;line-height: 40px;width: 80px;text-align: center;color:#fff;font-size: 14px;}
  .comCon{width: 76%;margin-top: 50px;}
  .comCon p{font-size: 17px;font-weight: bold;margin-bottom: 20px;}
  .comCon div.info{font-size: 14px;text-indent: 2em;line-height: 25px;}
  .comLogo{width: 150px;height: 150px;border-radius: 150px;}
  .comMain{width: 66.66%;margin: 0 auto;margin-top: 50px;}
  .name{font-size: 16px;}
  .accessory-list .main .price{font-size: 16px;}
  .mineCol{color: #00C5B0!important;}
  h2{
    font-size: 17px;
    font-weight: bold;
    margin: 20px 0;
  }
  .el-row{
    margin-bottom: 0;
  }
  .brief{
    margin-left: 15px;
    font-size: 14px;
    font-weight: bolder;
    display: inline-block !important;
    outline: none;
  }
  .pc{
    display: block;
  }
  .mobile{
    display: none;
    opacity: 0;
  }
  .accessory-list .pic {
    width: 176px;
    height: 176px;
    margin: 0 auto;
  }
  @media only screen and (max-width: 767px) and (min-width: 320px){
    .pc{
      display: none;
    }
    .mobile{
      display: block;
      opacity: 1;
    }
    .comCon {
      width: 99%;
      margin-top: 17px;
      margin-bottom: 20px;
    }
    .accessory-list .pic{
      border: none;
    }
    .accessory-list.col-4 > ul > li,
    .accessory-list.col-5 > ul > li{
      border-top: none;
    }
    .accessory-list .pic {
      width: 110px;
      height: 110px;
      margin: 0 auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/company/ComIndex.vue